import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import React, { Fragment, useContext, useState, useEffect } from "react";
import { APIContext } from "src/components/Contexts/APIContext"
import FeedbackTabButtonsViewModel from "../ViewModels/FeedbackTabButtonsViewModel";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";

interface IQAFeedbackTabButtonsProps {
    feedback: FeedbackTabButtonsViewModel;
    close: () => void;
}

export default function QAFeedbackTabButtons(props: IQAFeedbackTabButtonsProps) {
    const { get, showMessage, loading } = useContext(APIContext);
    const [cancelDialog, setCancelDialog] = useState<boolean>(false);
    const [status, setStatus] = useState<string>("");

    useEffect(() => {
        getStatus();
    }, [])

    const getStatus = () => {
        get('MonitoringCallInfo', `GetStatus?completeId=${props.feedback.completeId}`, (data) => setStatus(data));
    }

    const deleteScorecard = () => {
        get('MonitoringScorecard',
            `RemoveScorecardComplete?completeId=${props.feedback.completeId}`,
            () => {
                showMessage('success', 'Scorecard Deleted');
                props.close();
            });
    }

    const cancelScorecard = () => {
        get('MonitoringScorecard',
            `CancelScorecardComplete?completeId=${props.feedback.completeId}`,
            () => {
                showMessage('success', 'Scorecard Cancelled');
                props.close();
            });
    }

    const uncancelScorecard = () => {
        get('MonitoringScorecard',
            `UncancelScorecardComplete?completeId=${props.feedback.completeId}`,
            () => {
                showMessage('success', 'Scorecard Reissued');
                props.close();
            });
    }

    const reopenScorecard = () => {
        get('MonitoringScorecard',
            `ReopenScorecard?completeId=${props.feedback.completeId}`,
            () => {
                showMessage('success', 'Scorecard Reopened');
                props.close();
            });
    }

    const approveScorecard = () => {
        get('MonitoringScorecard',
            `ApproveScorecard?completeId=${props.feedback.completeId}`,
            () => {
                showMessage('success', 'Scorecard Approved');
                props.close();
            });
    }

    const handleDialogOpen = () => {
        setCancelDialog(true);
    };

    const handleDialogClose = () => {
        setCancelDialog(false);
    };

    return (
        !loading ?
            <Fragment>
                <Dialog
                    open={cancelDialog}
                    onClose={handleDialogClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"Are you sure you want to cancel?"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            This option should be used when the agent is no longer able to respond to the feedback.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleDialogClose}>Back</Button>
                        <Button onClick={cancelScorecard} autoFocus>
                            Confirm
                        </Button>
                    </DialogActions>
                </Dialog>
                {
                    status === "QA Approval Required" &&
                    <Grid size={12}>
                        <Button
                            disabled={loading}
                            variant='contained'
                            color='secondary'
                            fullWidth
                            onClick={() => approveScorecard()}>
                            Approve Scorecard
                        </Button>
                    </Grid>
                }
                {
                    (status === "Pending" || status === "Awaiting Feedback") &&
                    <Grid size={12}>
                        <Button
                            disabled={loading}
                            variant='contained'
                            color='secondary'
                            fullWidth
                            onClick={() => handleDialogOpen()}>
                            Cancel Scorecard
                        </Button>
                    </Grid>
                }
                {
                    (status === "Leaver") &&
                    <Grid size={12}>
                        <Button
                            disabled={loading}
                            variant='contained'
                            color='secondary'
                            fullWidth
                            onClick={() => uncancelScorecard()}>
                            Reissue Scorecard
                        </Button>
                    </Grid>
                }
                {
                    props.feedback.complete && status === "Pending" &&
                    < Grid size={12}>
                        <Button
                            disabled={loading}
                            variant='contained'
                            color='secondary'
                            fullWidth
                            onClick={() => reopenScorecard()}>
                            Reopen Scorecard
                        </Button>
                    </Grid>
                }
                {
                    !props.feedback.complete &&
                    <Grid size={12}>
                        <Button
                            disabled={loading}
                            variant='contained'
                            color='secondary'
                            fullWidth
                            onClick={() => deleteScorecard()}>
                            Delete Scorecard
                        </Button>
                    </Grid>
                }
            </Fragment>
            :
            <Grid container justifyContent="center" alignItems="center" marginTop={2}>
                <Grid>
                    <CircularProgress />
                </Grid>
            </Grid>
    );
}